import { render, staticRenderFns } from "./anexos.vue?vue&type=template&id=480bfa08"
import script from "./anexos.vue?vue&type=script&lang=js"
export * from "./anexos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports